<template>
  <v-row>
    <v-col cols="12" sm="8" class="mx-auto">
      <v-card flat>
        <v-card-title>
          <h3 class="font-weight-light">Item Categories</h3>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              $store.state.user.is_admin == 1 ||
              $store.state.user.components[5].roles.create == 1
            "
            color="orange"
            dark
            x-large
            rounded
            depressed
            @click="
              add_dialog = true;
              editing = false;
              name = '';
              description = '';
            "
            >Create New Category</v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-text-field
            color="orange"
            type="search"
            placeholder="Search"
            v-model="search"
            filled
            flat
            rounded
          >
          </v-text-field>

          <v-skeleton-loader type="table" v-if="progress"></v-skeleton-loader>
          <v-data-table
            v-else
            :items="categories"
            :headers="headers"
            :search="search"
            fixed-header
            height="90vh"
            :items-per-page="50"
          >
            <template v-slot:item.name="{ item }">
              {{ item.name
              }}<sup v-if="item.archived">
                <v-icon color="red" x-small>mdi-archive-outline</v-icon>
              </sup>
            </template>
            <template v-slot:item.item_count="{ item }">
              <v-chip
                small
                color="orange lighten-5"
                class="text-primary font-weight-bold"
                >{{ item.item_count }}</v-chip
              >
            </template>
            <template v-slot:item.id="{ item }">
              <v-menu offset-y transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon color="orange"
                    ><v-icon>mdi-dots-horizontal</v-icon></v-btn
                  >
                </template>
                <v-list v-if="CAN_EDIT">
                  <v-list-item
                    @click="edit(item)"
                    :disabled="item.name == 'Uncategorised'"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="archiveCategory(item)"
                    :disabled="item.name == 'Uncategorised'"
                  >
                    <v-list-item-title>{{
                      item.archived ? "Unarchive" : "Archive"
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="delete_cat(item)"
                    :disabled="item.name == 'Uncategorised'"
                  >
                    <v-list-item-title class="red--text">
                      Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog width="400" v-model="add_dialog">
      <v-card>
        <v-card-title
          >{{ editing ? "Edit" : "Create" }}
          {{ "Category" }}
        </v-card-title>
        <v-card-text>
          <v-form ref="cat_form" @keyup.native.enter="save_cat">
            <v-text-field
              color="orange"
              :label="'Name'"
              v-model="name"
              outlined
              :rules="nameRules"
            ></v-text-field>
            <v-textarea
              color="orange"
              :label="'Description'"
              v-model="description"
              rows="5"
              outlined
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="saving_progress"
            color="orange"
            text
            @click="save_cat()"
            >{{ "Save" }} {{ editing ? "Changes" : "" }}</v-btn
          >
          <v-btn
            @click="
              name = '';
              description = '';
              add_dialog = false;
            "
            text
            >{{ "Cancel" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success_message">
      {{ success_msg }}
      <v-btn
        color="success"
        text
        @click="success_message = false"
        timeout="360"
      >
        {{ "Close" }}
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="error_message" color="error">
      {{ error_msg }}
      <v-btn color="light" text @click="error_message = false" timeout="360">
        {{ "Close" }}
      </v-btn>
    </v-snackbar>
    <v-dialog :persistent="saving_progress" width="500" v-model="delete_dialog">
      <v-card>
        <v-card-title>Confirm Delete</v-card-title>
        <v-card-text>
          <h2>Do you want to delete this category?</h2>
          <p>This action cannot be undone.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="saving_progress"
            @click="do_delete()"
            block
            color="red"
            dark
            x-large
            rounded
            depressed
            >Delete Category
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :persistent="saving_progress"
      width="500"
      v-model="archive_dialog"
      v-if="selectedCategory"
    >
      <v-card>
        <v-card-title
          >Confirm
          {{
            selectedCategory.archived ? "Unarchive" : "Archive"
          }}</v-card-title
        >
        <v-card-text>
          <h2>
            Do you want to
            {{ selectedCategory.archived ? "unarchive" : "archive" }} this
            category?
          </h2>
          <p v-if="!selectedCategory.archived">
            Archived categories can be restored later if needed.
          </p>
          <p v-else>This category will be available again.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="saving_progress"
            @click="do_archive()"
            block
            color="red"
            dark
            x-large
            rounded
            depressed
            >{{ selectedCategory.archived ? "Unarchive" : "Archive" }} Category
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "itemcategoriesComponent",
  data() {
    return {
      delete_dialog: false,
      archive_dialog: false,
      selectedCategory: null,
      editing: false,
      id: 0,
      saving_progress: false,
      error_message: false,
      error_msg: "",
      success_message: false,
      success_msg: "",
      add_dialog: false,
      name: "",
      description: "",
      nameRules: [
        (v) => !!v || "Required",
        //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      progress: false,
      search: "",
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name",
        },
        { text: "Description", value: "description" },
        {
          text: "Item Count",
          value: "item_count",
          align: "center",
        },
        { text: "Actions", value: "id", align: "center" },
      ],
      categories: [],
    };
  },
  computed: {
    CAN_EDIT() {
      if (this.$store.state.user.is_admin === 1) {
        return true;
      } else return this.$store.state.user.components[5].roles.edit === 1;
    },
    CAN_DELETE() {
      if (this.$store.state.user.is_admin === 1) {
        return true;
      } else return this.$store.state.user.components[5].roles.delete === 1;
    },
    CAN_ADD() {
      if (this.$store.state.user.is_admin === 1) {
        return true;
      } else return this.$store.state.user.components[5].roles.create === 1;
    },
  },
  methods: {
    archiveCategory(item) {
      this.selectedCategory = item;
      this.id = item.id;
      this.archive_dialog = true;
    },
    save_cat() {
      if (this.$refs.cat_form.validate()) {
        this.saving_progress = true;

        let formdata = new FormData();
        formdata.append("name", this.name);
        formdata.append("description", this.description);
        formdata.append("id", this.id);
        if (!this.editing) {
          axios
            .post("/api/itemcategory", formdata)
            .then((res) => {
              this.success_msg = "Category saved";
              this.success_message = true;
              this.name = "";
              this.description = "";
              this.add_dialog = false;
              this.get_categories();
              this.saving_progress = false;
            })
            .catch((error) => {
              // if (error.response.status == 302) {
              //   this.error_msg = error.response.data;
              // } else {
              //   this.error_msg = this.$t("item.category_save_failed");
              // }
              // this.error_message = true;
              this.saving_progress = false;
            });
        } else {
          axios
            .post("/api/itemcategory/" + this.id, formdata)
            .then((res) => {
              this.get_categories();
              this.saving_progress = false;
              this.add_dialog = false;
            })
            .catch((error) => {
              // if (error.response.status == 302) {
              //   this.error_msg = error.response.data;
              // } else {
              //   this.error_msg = this.$t("item.category_save_failed");
              // }
              // this.error_message = true;
              this.saving_progress = false;
            });
        }
      }
    },

    do_archive() {
      this.saving_progress = true;
      const isArchived = this.selectedCategory.archived;
      axios
        .post(`/api/itemcategory/${this.id}/archive`)
        .then((res) => {
          this.saving_progress = false;
          this.archive_dialog = false;
          this.success_msg = isArchived
            ? "Category unarchived successfully"
            : "Category archived successfully";
          this.success_message = true;
          this.get_categories();
        })
        .catch((error) => {
          this.saving_progress = false;
          this.error_msg =
            error.response?.data?.message ||
            `Failed to ${isArchived ? "unarchive" : "archive"} category`;
          this.error_message = true;
        });
    },
    do_delete() {
      axios
        .delete("/api/itemcategory/" + this.id)
        .then((res) => {
          this.saving_progress = false;
          this.delete_dialog = false;
          this.get_categories();
          this.success_msg = "Category deleted";
          this.success_message = true;
        })
        .catch((error) => {
          // if (error.response.status == 302) {
          //   this.error_msg = error.response.data;
          // } else {
          //   this.error_msg = this.$t("item.category_deleted_failed");
          // }
          // this.error_message = true;
          this.saving_progress = false;
        });
    },

    edit(item) {
      this.id = item.id;
      this.name = item.name;
      this.description = item.description;
      this.editing = true;
      this.add_dialog = true;
    },
    delete_cat(item) {
      if (Number(item.item_count) > 0) {
        this.error_msg = "Category has items";
        this.error_message = true;
        return false;
      }
      this.id = item.id;

      this.delete_dialog = true;
    },
    get_categories() {
      this.progress = true;
      axios.get("/api/itemcategories").then((res) => {
        this.categories = res.data;

        this.progress = false;
      });
    },
  },
  mounted() {
    this.get_categories();
  },
};
</script>

<style scoped></style>
